import React from 'react';
import {HTMLTrans} from '../Common/Translations';

const autoCompleteFeature = (WrappedComponent) => {
    return class AutoCompleteFeature extends React.Component{
        constructor(props) {
            super(props);
            this.props = props;
            this.timer;
            this.onClickItem = this.onClickItem.bind(this)         
        }
    
        onClickItem(value) {
            this.setState({results: ''});
            let url = "/" + this.props.tRoute(value.url);
            window.location.href = window.location.origin + url.replace(/\/{2,}/g,"/");
        }
    
        filterItems(items, type) {
            return (
                items.filter(function(item){
                    return item.type === type
                })
            )
        }
    
        showDropDown(categories, themes, categoryIsEmpty, themeIsEmpty, currency, state, handleSearchAll) {
            return (
                <ul>
                    {this.categoriesView(categoryIsEmpty)}
                    { 
                        categories.map((category, index) => 
                        <li
                            key={index} 
                            onClick={() => this.onClickItem(category)}
                            className="d-flex align-items-center category dropdown"
                        >
                            <h className="pl-2 dropdown">
                                {category.title}
                                <span className="subheader dropdown">
                                    &nbsp;
                                    <HTMLTrans id="navbar.dropdown_slash">/</HTMLTrans>
                                    &nbsp;
                                    {category.productFamily}
                                </span>
                            </h>
                        </li>
                        )              
                    }
                    {this.themesView(themeIsEmpty)}
                    { 
                        themes.map((theme, index) => 
                        <li 
                            key={index} 
                            onClick={() => this.onClickItem(theme)}
                            className="d-flex align-items-center theme dropdown"
                        >
                            <img src={theme.thumbnail_url} className="dropdown"/>
                            <div className="pl-2 theme dropdown" >
                                <span dangerouslySetInnerHTML={{ __html: this.getBoldedString(theme.title, state.value.trim())}} />
                                <p className="description">
                                    {   
                                    (theme.partial_description !== null) &&
                                    <span dangerouslySetInnerHTML={{ __html: this.processPartialDescription(theme.partial_description, theme.partial_description_field, state.value.trim(), state.maxLength)}} />
                                    }
                                </p>
                            </div>
                            <div className="mla-auto pl-2 dropdown from">
                                {
                                    (theme.price_from) && (theme.slash_price) && 
                                    <div>  
                                        <HTMLTrans id="navbar.dropdown_from">from</HTMLTrans> 
                                        <span className="price-with-strike">{currency + ' ' + theme.price_from}</span>
                                        <br/>
                                        <span className="slash-price">{currency + ' ' + theme.slash_price}</span>
                                    </div>
                                }
                                {
                                    (theme.price_from) && (!theme.slash_price) && 
                                    <div>
                                        <HTMLTrans id="navbar.dropdown_from">from</HTMLTrans> 
                                        <br/>
                                        <span className="price">{currency + ' ' + theme.price_from}</span>
                                    </div>
                                }
                            </div>
                        </li>
                        ) 
                    }
                    {this.seeAllProductsView(themeIsEmpty, state, handleSearchAll)}
                </ul>
            );
        }
    
        renderSuggestions = (products) => {
            const categories = this.filterItems(products, 'product_categories');
            const themes = this.filterItems(products, 'product_themes');
    
            const categoryIsEmpty = categories.length === 0 ? true : false;
            const themeIsEmpty = themes.length === 0 ? true : false;
    
            return { categories: categories, themes: themes, categoryIsEmpty: categoryIsEmpty, themeIsEmpty: themeIsEmpty };
        }
    
        categoriesView(categoryIsEmpty){
            if (!categoryIsEmpty) {
                return <li className="dropdown-header dropdown" key="categories"><HTMLTrans id="navbar.dropdown_categories_header">Categories</HTMLTrans></li>
            }
        }
    
        themesView(themeIsEmpty){
            if (!themeIsEmpty) {
                return <li className="dropdown-header dropdown" key="products"><HTMLTrans id="navbar.dropdown_products_header">Products</HTMLTrans></li>
            }
        }

        seeAllProductsView(themeIsEmpty, state, handleSearchAll){
            if (!themeIsEmpty) {
                return <li className="search-all-items dropdown" onClick={() => handleSearchAll(state.value)}>
                    <i className="fa fa-search mt-2 search-icon-bottom"></i>
                    <HTMLTrans id="navbar.dropdown_see_all_products_for">See all products for</HTMLTrans> 
                    <b><span>{' ' + state.value}</span></b>
                </li>
            }
            
            return <li className="search-no-products-found dropdown">
                <i className="fa fa-search mt-2 search-icon-bottom"></i>
                <HTMLTrans id="navbar.dropdown_no_products_found">No products found</HTMLTrans> 
            </li>
        }
    
        getBoldedString(string, query, result=''){
            if (!string.toLowerCase().includes(query.toLowerCase())){
                return result += string;
            }
            let length = query.length;
            let start = string.toLowerCase().indexOf(query.toLowerCase());
            let end = start + length;
    
            result += string.substring(0,start) + '<b>' + string.substring(start, end) + '</b>';
    
            return this.getBoldedString(string.substring(end), query, result);
        } 

        processPartialDescription(string, field, query, maxLength) {
            if ((field === 'product_family') || (field ==='product_code') || (string.length <= maxLength)) {
                return this.getBoldedString(string, query);
            }
            if (query.length >= maxLength) {
                return '...' + '<b>' + string.substr(string.toLowerCase().indexOf(query.toLowerCase()), maxLength) + '</b>' + '...';
            } 
            return '...' + this.getBoldedString(this.stripCharacters(string, query, maxLength), query) + '...'
        }

        stripCharacters(string, query, maxLength){
            let start = string.toLowerCase().indexOf(query.toLowerCase());
            let end = string.toLowerCase().indexOf(query.toLowerCase()) + query.length;
       
            let left = string.substring(0, start).length;
            let right = string.substring(end, string.length).length;
       
            if (left <= right){
                let [startIndex,  newBalance] = this.stripLeft(left, start, ((maxLength-query.length) / 2));
                let [endIndex, _ ] = this.stripRight(right, end, newBalance);
                return string.substring(startIndex, endIndex);
            }
      
            let [endIndex, newBalance] = this.stripRight(right, end, ((maxLength-query.length) / 2));
            let [startIndex, _ ] = this.stripLeft(left, start, newBalance);
            return string.substring(startIndex, endIndex);
        }
       
        stripLeft(length, start, balance){
            if (length - balance >= 0) {
                start -= balance;
            }
            else {
                start -= length;
                balance += (balance - length);
            }
            return [start, balance]
        }
       
        stripRight(length, end, balance){
            if (length - balance >= 0){
                end += balance;
            }
            else {
                end += length;
                balance += (balance - length);
            }
            return [end, balance]
        }
     

        render() {
            return (
                <WrappedComponent 
                    onClickItem={this.onClickItem}
                    filterItems={this.filterItems}
                    showDropDown={this.showDropDown}
                    renderSuggestions={this.renderSuggestions}
                    categoriesView={this.categoriesView}
                    themesView={this.themesView}
                    seeAllProductsView={this.seeAllProductsView}
                    getBoldedString={this.getBoldedString}
                    processPartialDescription={this.processPartialDescription}
                    stripCharacters={this.stripCharacters}
                    stripLeft={this.stripLeft}
                    stripRight={this.stripRight}
                    {...this.props}
                />
            )   
        }
    }
}

export default autoCompleteFeature;


// WEBPACK FOOTER //
// ./src/Nav/AutoCompleteFeature.js